import { render } from "./StandardDataMaterial.vue?vue&type=template&id=7dfae04f"
import script from "./StandardDataMaterial.vue?vue&type=script&lang=js"
export * from "./StandardDataMaterial.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__